import React from 'react';
import styled from 'styled-components';

import Color from '../../../utils/colors';
import dataPhases from '../consts/dataPhases';
import typograf from '../../../utils/typograf';
import { Font, FontWeight } from '../../../utils/fonts';

import ArrowSmallIcn from '../assets/arrow-small-black.svg';

class PhasesMenu extends React.PureComponent {
    render() {
        const {
            phase, changePhase,
        } = this.props;
        return (
            <Container>
                {dataPhases.map((p, index) => (
                    <Item
                        key={index.toString()}
                        isActive={phase === index}
                        isPassed={phase > index}
                        onClick={() => changePhase(index)}
                    >
                        {phase === index && <img alt="arrow-small-icn" src={ArrowSmallIcn} />}
                        {typograf.execute(p.name)}
                    </Item>
                ))}
            </Container>
        );
    }
}

const Container = styled.div`
  position: relative;
  width: 352px;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  
  padding: 0 33px 0 60px;

  background-color: #F5F5F5;
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  
  text-transform: uppercase;
  ${Font.HEADLINE};
  ${FontWeight.REGULAR};
  font-size: 14px;
  line-height: 16px;
  
  cursor: pointer;

  color: ${({ isActive, isPassed }) => (
        isActive ? '#000' : (isPassed ? Color.SECONDARY : 'rgba(0, 0, 0, 0.32)')
    )};
  
  img {
    width: 34px;
    height: 10px;
    
    margin-right: 10px;
  }
  
  &:not(:last-child) {
    margin-bottom: 64px;
  }
`;

export default PhasesMenu;
